export function resolveReservationQaTermsUrl(
  browserOrigin: string,
  environment: unknown,
  configuredUrl: unknown,
): string | null {
  const qaOrigin: Location['origin'] = 'https://qa.molibra.pl';
  const qaTermsUrl: string = `${qaOrigin}/zasady-rezerwacji.html`;
  return environment === 'qa' && browserOrigin === qaOrigin && configuredUrl === qaTermsUrl
    ? qaTermsUrl
    : null;
}
